module.exports = __webpack_public_path__ + "public/images/curated-hero-section-heart.e8e1ef1a4eb45e1539c30d85c3eaa2bb.svg";